import { Injectable } from '@angular/core';
import { BehaviorSubject } from 'rxjs';
import { Rect } from '../classes/rect.class';

@Injectable({
  providedIn: 'root',
})
export class DragDropService {
  hovering$ = new BehaviorSubject<{ id: string; type: string; position: Rect }>(undefined);
  dragging$ = new BehaviorSubject<{
    id: string;
    uid: string;
    type: string;
    startPosition: Rect;
    position: Rect;
    offset: Rect;
    triggered: boolean;
  }>(undefined);
  dropped$ = new BehaviorSubject<{
    id: string;
    uid: string;
    type: string;
    target: string;
    targetType: string;
    position: Rect;
    offset: Rect;
    context: string;
  }>(undefined);
}
